"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _HeadMenu = _interopRequireDefault(require("./HeadMenu"));

var _contact = _interopRequireDefault(require("../../assets/images/contact.svg"));

var _SocialLink = _interopRequireDefault(require("./SocialLink"));

var _ArrowLink = _interopRequireDefault(require("./ArrowLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SOCIAL_LINKS = ['facebook', 'twitter', 'instagram', 'linkedin', 'youtube', 'snapchat', 'googleplus'];

var ContactMenu = /*#__PURE__*/function (_Component) {
  _inherits(ContactMenu, _Component);

  var _super = _createSuper(ContactMenu);

  function ContactMenu() {
    var _this;

    _classCallCheck(this, ContactMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_renderSections", function () {
      return _this.props.sections.map(function (l, i) {
        return (0, _preact.h)("li", {
          id: "mtn-header-top-contact-section-".concat(i),
          key: l.href,
          className: "mtn-m-contact__section"
        }, (0, _preact.h)("label", {
          className: "mtn-m-contact__label"
        }, l.label), (0, _preact.h)(_ArrowLink["default"], {
          id: "mtn-header-top-contact-link-".concat(i),
          linksRenderFunction: _this.props.linksRenderFunction,
          href: l.href,
          label: l.link
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderSocial", function () {
      var contactSocial = _this.props.contactSocial;

      if (contactSocial) {
        return (0, _preact.h)("li", {
          className: "mtn-m-contact__section"
        }, (0, _preact.h)("label", {
          className: "mtn-m-contact__label mtn-m-contact__label--margin"
        }, contactSocial.title || contactSocial.title === '' ? '' : 'Volg ons'), SOCIAL_LINKS.map(function (s) {
          return (0, _preact.h)(_SocialLink["default"], {
            id: "mtn-header-top-social-link-".concat(s),
            key: s,
            name: s,
            url: contactSocial[s]
          });
        }));
      }

      return null;
    });

    return _this;
  }

  _createClass(ContactMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sections = _this$props.sections,
          title = _this$props.title,
          buttonLabel = _this$props.buttonLabel;

      if (title || sections && sections.length) {
        return (0, _preact.h)(_HeadMenu["default"], {
          id: "mtn-header-top-contact",
          className: "mtn-o-header__contact",
          icon: _contact["default"],
          label: buttonLabel,
          content: (0, _preact.h)("div", {
            className: "mtn-m-contact"
          }, (0, _preact.h)("h3", {
            id: "mtn-header-top-contact-title",
            className: "mtn-m-contact__title mtn-ts-h5 u-mtn-color-text"
          }, title || 'Contacteer stad Antwerpen'), (0, _preact.h)("ul", {
            id: "mtn-header-top-contact-sections",
            className: "mtn-m-contact__sections"
          }, this._renderSections(), this._renderSocial()))
        });
      }

      return null;
    }
  }]);

  return ContactMenu;
}(_preact.Component);

ContactMenu.defaultProps = {
  title: '',
  sections: [],
  buttonLabel: 'Contact'
};
var _default = ContactMenu;
exports["default"] = _default;